import React from "react";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

function IdAutoCompleteField({ field, form, label, options = [], onValueChange, isRequired, idKey = "id", onClose, isLoading = false, ...props }) {
	const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
	const sortedOptions = React.useMemo(() => {
		const seen = new Set();
		return [...options]
			.sort((a, b) => a?.label?.localeCompare(b?.label))
			.filter(option => {
				if (seen.has(option?.id)) return false;
				seen.add(option?.id);
				return true;
			});
	}, [options]);

	return (
		<FormControl fullWidth error={!!errorText}>
			{field.name && (
				<InputLabel sx={{ ml: -1.6, textTransform: "capitalize" }} shrink htmlFor={field.name} >
					<Typography variant="h6">
						{label}
						{isRequired && (
							<Typography variant="h5" color="error" component="span">
								{" *"}
							</Typography>
						)}
					</Typography>
				</InputLabel>
			)}
			<Autocomplete
				{...props}
				id={field.name}
				// filterOptions={(opts, { inputValue }) =>
				// 	opts.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()))
				// }
				filterOptions={(opts, { inputValue }) =>
					opts.filter(option =>
						(option?.label || "")?.toLowerCase()?.includes((inputValue || "")?.toLowerCase())
					)
				}
				noOptionsText={<Typography variant="h6">{props.noOptionsText || "No Option"}</Typography>}
				options={sortedOptions}
				// value={sortedOptions.find((option) => option.value === field.value) ?? null}
				loading={isLoading}
				sx={{
					backgroundColor: "#F7FAFF",
					border: "1px solid #4169E1",
					borderRadius: "5px",
					mt: 2,
					"& fieldset": { border: "none" },
					"& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding: "0", height: "25px", textTransform: "capitalize" },
					"& .MuiInputBase-input": { fontSize: "12px", textTransform: "capitalize" },
					"& .MuiInputBase-input.Mui-disabled": {
						color: "#4d4d4d",
						WebkitTextFillColor: "#4d4d4d",
					}
				}}
				// // noOptionsText={<Typography variant="h6">{props.noOptionsText}</Typography>}
				// onChange={(_, value) => {
				// 	if (value === null) {
				// 		form.setFieldValue(field.name, "");
				// 	}
				// 	if (value) {
				// 		// Set the ID value instead of the display value
				// 		form.setFieldValue(field.name, value[idKey]);
				// 		onValueChange?.(value);
				// 	}
				// }}
				onChange={(_, value) => {
					if (value === null) {
						form.setFieldValue(field.name, "");
						onValueChange?.(null);
					} else {
						form.setFieldValue(field.name, value[idKey]);
						onValueChange?.(value);
					}
				}}

				onClose={(event, reason) => {
					onClose?.(event, reason);
				}}
				renderOption={(props, option) => (
					<li {...props} key={option[idKey] || option?.id}>
						<Typography variant="h6" sx={{ textTransform: "capitalize" }}>{option?.label}</Typography>
					</li>
				)}
				renderInput={(params) => (
					<TextField
						placeholder={label ? `${label}` : "Select"}
						label={undefined}
						name={field.name}
						{...params}
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<React.Fragment>
									{isLoading ? <CircularProgress color="inherit" size={20} /> : null}
									{params.InputProps.endAdornment}
								</React.Fragment>
							),
						}}
					/>
				)}

				onInputChange={(_, newValue, reason) => {
                    if (reason === "input") {
                        props.onSearchChange?.(newValue);
                    }

                 
                }}

				getOptionLabel={(option) => option.label || ""}
				isOptionEqualToValue={(option, value) => option[idKey] === value[idKey]}
				value={sortedOptions.find((option) => option[idKey] === field.value) ?? null}
			/>
			{errorText && <Typography variant="h6" fontSize={"10px"} color="red">{errorText}</Typography>}
		</FormControl>
	);
}

export { IdAutoCompleteField }; 



